import { actionCreator, ActionReturnType, Loading, loadingFailed, loadingFinished, loadingIsLoading, loadingNotStarted } from "@itk/typescript-utils";
import { TAddEditConfigurationDialog, TFormData } from "./add-edit-configuration-dialog-types";
import { Model_ConfiguratorProductGet, Model_ProjectLineItemCreatePut, Model_ProjectLineItemExtendedGet, Model_ProjectProductsFilterPut, Model_SystemPackageGet } from "src/backend/openapi/v1";
import { SinglePicture } from "src/pages/product-details/product-details-types";

export enum Action {
  SetAddEditConfigurationDialog = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:SETADDEDITCONFIGURATIONDIALOG",

  SetFormData = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:SETFORMDATA",

  GetSystemPackagesRequest = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:GETSYSTEMPACKAGESREQUEST",
  GetSystemPackagesSuccess = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:GETSYSTEMPACKAGESSUCCESS",
  GetSystemPackagesFail = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:GETSYSTEMPACKAGESFAIL",

  GetProductsRequest = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:GETPRODUCTSREQUEST",
  GetProductsSuccess = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:GETPRODUCTSSUCCESS",
  GetProductsFail = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:GETPRODUCTSFAIL",

  UpdateProductPictures = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:UPDATEPRODUCTPICTURES",

  CreateProjectLineItemRequest = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:ADD-EDIT-CONFIGURATION-DIALOG:ADD-EDIT-CONFIGURATION-DIALOG-STORE.TS:ACTION:CREATEPROJECTLINEITEMREQUEST"
}

type TAddEditConfigurationDialogState = {
  addEditConfigurationDialog?: TAddEditConfigurationDialog;
  systemPackagesState: Loading<Model_SystemPackageGet[]>;
  productsState: Loading<Model_ConfiguratorProductGet[]>;
  productPictures: SinglePicture[];
  formData: TFormData;
};

const initialState: TAddEditConfigurationDialogState = {
  addEditConfigurationDialog: undefined,
  systemPackagesState: loadingNotStarted,
  productsState: loadingNotStarted,
  productPictures: [],
  formData: {
    viewMode: "FULL"
  }
};

export const addEditConfigurationDialogActions = {
  setAddEditConfigurationDialog: (data: TAddEditConfigurationDialogState["addEditConfigurationDialog"]) => actionCreator(Action.SetAddEditConfigurationDialog, { data }),

  setFormData: (data: TAddEditConfigurationDialogState["formData"]) => actionCreator(Action.SetFormData, { data }),

  getSystemPackagesRequest: () => actionCreator(Action.GetSystemPackagesRequest),
  getSystemPackagesSuccess: (data: Model_SystemPackageGet[]) => actionCreator(Action.GetSystemPackagesSuccess, { data }),
  getSystemPackagesFail: () => actionCreator(Action.GetSystemPackagesFail),

  getProductsRequest: (projectId: string, data: Model_ProjectProductsFilterPut) => actionCreator(Action.GetProductsRequest, { projectId, data }),
  getProductsSuccess: (data: Model_ConfiguratorProductGet[]) => actionCreator(Action.GetProductsSuccess, { data }),
  getProductsFail: () => actionCreator(Action.GetProductsFail),

  updateProductPictures: (productPictures: TAddEditConfigurationDialogState["productPictures"]) => actionCreator(Action.UpdateProductPictures, { productPictures }),

  createProjectLineItemRequest: (data: Model_ProjectLineItemCreatePut, callBack: (isSuccess: boolean, data?: Model_ProjectLineItemExtendedGet) => void) =>
    actionCreator(Action.CreateProjectLineItemRequest, { data, callBack })
};

export const addEditConfigurationDialogReducer = (state = initialState, action: ActionReturnType<typeof addEditConfigurationDialogActions>): TAddEditConfigurationDialogState => {
  switch (action.type) {
    case Action.SetAddEditConfigurationDialog:
      return { ...state, addEditConfigurationDialog: action.payload.data, formData: action.payload.data === undefined ? initialState.formData : state.formData };

    case Action.SetFormData:
      const newFilter = { ...state.formData.productsFilter, ...action.payload.data.productsFilter };
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.payload.data,
          productsFilter: newFilter
        }
      };

    case Action.GetSystemPackagesRequest:
      return { ...state, systemPackagesState: loadingIsLoading };
    case Action.GetSystemPackagesSuccess:
      return { ...state, systemPackagesState: loadingFinished(action.payload.data) };
    case Action.GetSystemPackagesFail:
      return { ...state, systemPackagesState: loadingFailed };

    case Action.GetProductsRequest:
      return { ...state, productsState: loadingIsLoading };
    case Action.GetProductsSuccess:
      return { ...state, productsState: loadingFinished(action.payload.data) };
    case Action.GetProductsFail:
      return { ...state, productsState: loadingFailed };

    case Action.UpdateProductPictures:
      return { ...state, productPictures: [...state.productPictures, ...action.payload.productPictures] };

    default:
      return state;
  }
};
